<script setup lang="ts">
    import { __ } from '@/js/stores/expressions';
    import { CalendarIcon, LinkIcon, UserIcon } from '@lucide/vue';

    interface Props {
        createdBy: string;
        createdAt: string;
        expirationDate: string;
    }

    const props = defineProps<Props>();

    const formatDate = (date: string): string => {
        const split = date.split('T');
        if (split.length > 0) {
            return split[0];
        }
        return date;
    };

    const sections = [
        {
            icon: UserIcon,
            label: __('dashboard-report-created-by'),
            value: props.createdBy,
        },
        {
            icon: CalendarIcon,
            label: __('dashboard-report-created-at'),
            value: formatDate(props.createdAt),
        },
        {
            icon: LinkIcon,
            label: __('dashboard-report-expiry-date'),
            value: formatDate(props.expirationDate),
        },
    ];
</script>
<template>
    <div
        class="p-6 mt-2 bg-white flex justify-between shadow-md rounded-lg flex-col items-center gap-2 md:h-25 md:flex-row md:gap-0.5"
    >
        <div
            v-for="(section, index) in sections"
            :key="index"
            class="grow h-full flex justify-center items-center"
            :class="index === 1 ? 'md:border-gray-light md:border-x-1' : ''"
        >
            <div>
                <div class="flex gap-2 justify-center">
                    <component :is="section.icon" class="size-5" />
                    <p :aria-label="section.label" class="text-lg font-semibold">
                        {{ section.label }}
                    </p>
                </div>

                <p class="text-center">
                    {{ section.value }}
                </p>
            </div>
        </div>
    </div>
</template>
